let cachedConfig = null;
let loadPromise = null;

/**
 * Loads Mixpanel (and other non-build) settings at runtime from
 * /runtime-config/{REACT_APP_ENV}.json so secrets stay out of .env / SSM env-config.
 */
export default function loadRuntimeConfig() {
  if (cachedConfig) {
    return Promise.resolve(cachedConfig);
  }

  if (loadPromise) {
    return loadPromise;
  }

  const env = process.env.REACT_APP_ENV || "QA";
  const url = `${process.env.PUBLIC_URL || ""}/runtime-config/${env}.json`;

  loadPromise = fetch(url, { cache: "no-store" })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Failed to load runtime config: ${res.status} ${url}`);
      }
      return res.json();
    })
    .then((config) => {
      cachedConfig = config || {};
      return cachedConfig;
    })
    .catch((err) => {
      loadPromise = null;
      console.error(err);
      cachedConfig = {};
      return cachedConfig;
    });

  return loadPromise;
}
